import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=1c397c97&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"
import style0 from "./Details.vue?vue&type=style&index=0&id=1c397c97&prod&lang=css"
import style1 from "./Details.vue?vue&type=style&index=1&id=1c397c97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c397c97",
  null
  
)

export default component.exports